/**
 * DaysBadge Molecule Component
 * Displays number of days in a badge
 */

import { cn } from '@/lib/utils'

interface DaysBadgeProps {
	days: number
	className?: string
	variant?: 'outlined' | 'plain'
}

export function DaysBadge({
	days,
	className,
	variant = 'outlined',
}: DaysBadgeProps) {
	const base = 'flex flex-col items-center justify-center'
	const outlined = 'min-w-[60px] h-[60px] border-2 border-[#09194D] rounded-lg'
	return (
		<div className={cn(base, variant === 'outlined' && outlined, className)}>
			<span className='font-["Bricolage_Grotesque"] text-xs text-gray-600 uppercase'>
				Cantidad
			</span>
			<span className='font-["Bricolage_Grotesque"] text-xs text-gray-600 uppercase'>
				de días
			</span>
			<span className='font-["Bricolage_Grotesque"] text-2xl font-black text-[#09194D]'>
				{isNaN(days) ? '-' : days}
			</span>
		</div>
	)
}
